export default "__VITE_ASSET__369503ba__"